import { Component } from '@angular/core';
import { HttpModule } from '@angular/http';
import {Injectable, Inject} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import { RouterModule, Routes, Router, NavigationEnd, NavigationStart } from '@angular/router';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  constructor(private NgxRolesService: NgxRolesService, private NgxPermissionsService: NgxPermissionsService, private http: Http, private router:Router) {
    NgxPermissionsService.loadPermissions(["A"]);
    this.NgxRolesService.addRole("GUEST", ['A'] );
  }

  ngOnInit() {
   
    this.NgxPermissionsService.loadPermissions(["A"]);

      this.NgxRolesService.flushRoles();

      this.NgxRolesService.addRole(localStorage.getItem('currentUserRole'), ['A']  );
    
    this.router.events
      .filter(event => event instanceof NavigationStart)
      .subscribe(e => {        
        
      });  

    this.router.events.subscribe((evt:any) => {
      if (!(evt instanceof NavigationStart)) {
        if(evt.url == '/' || evt.url == '/login') {
            localStorage.setItem('previousUrl','calendar');
        } else {
            localStorage.setItem('previousUrl',evt.url);        
        }
      } 
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }
}



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/app.component.ts